import React, { useEffect, useState } from 'react'
import { occupationContext } from './context'
import { useDispatch, useSelector } from 'react-redux'
import { AlertError, Loader } from '../../../components'
import { fetchOccupations } from '../slice'

const OccupationProvider = ({ children }) => {
  const dispatch = useDispatch()
  const language = useSelector(state => state.system.language)
  const status = useSelector(state => state.occupation.status)
  const error = useSelector(state => state.occupation.error)
  const [errorMessage, setErrorMessage] = useState(null)
  const occupations = useSelector(state => state.occupation.data)
  const [occupationOptions, setOccupationOptions] = useState([])

  useEffect(() => {
    if(status === 'idle'){
      dispatch(fetchOccupations())
    }
  }, [status, dispatch])

  useEffect(() => {
    if(error) setErrorMessage(error)
  }, [error])

  const formatter = React.useCallback(
    (data) => ({value: data.id, label: data.name[language.name]}),
    [language],
  );

  useEffect(() => {
    if(status === 'succeeded'){
      setOccupationOptions(occupations.map(a => formatter(a)))
    }
  }, [status, language, occupations, formatter])

  return (
    <occupationContext.Provider value={{
      occupations,
      occupationOptions
    }}>
      {
        status === 'idle' &&
        <div className="text-center py-5 text-sm">
          Some data need to be fetched. <span className="link cursor-pointer" onClick={() => dispatch(fetchOccupations())}>Fetch</span>
        </div>
      }
      {
        status === 'loading' &&
        <div className="text-center py-5 text-sm">
          <Loader />
        </div>
      }
      {
        status === 'failed' &&
        <div className="text-center py-5 text-sm">
          <div className="mb-4">
            <p>Some data failed to be fetched.</p>
            <div>
              <span className="link cursor-pointer mr-4" onClick={() => dispatch(fetchOccupations())}>
                Retry
              </span>
            </div>
          </div>
          {
            errorMessage !== null &&
            <AlertError message={error} onClose={() => setErrorMessage(null)}/>
          }
        </div>
      }
      {
        status === 'succeeded' &&
        children
      }
    </occupationContext.Provider>
  );
};

export { OccupationProvider }
